import { render, staticRenderFns } from "./ClientCharge.vue?vue&type=template&id=1b3ae37c&scoped=true"
import script from "./ClientCharge.vue?vue&type=script&lang=js"
export * from "./ClientCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3ae37c",
  null
  
)

export default component.exports